import { EmailNotificationPreferences } from "@/gql/__generated__/graphql";
import {
  EmailNotificationCategoryType,
  EmailNotificationItem
} from "../types/emailNotification.type";

export function generateEmailNotificationCategories(
  data: EmailNotificationPreferences | undefined | null
): EmailNotificationItem[] {
  if (!data) return [];

  const keyVal: [string, boolean][] = Object.entries(data).filter(
    ([key]) => typeof key === "string" && key !== "__typename"
  ) as [string, boolean][];

  return keyVal.map(([key, value]) => {
    const category = formatCategory(key);
    return {
      title: formatTitle(key),
      description: getDescription(category),
      category,
      value
    };
  });
}

function formatTitle(category: string) {
  let temp = category.substring(0, category.indexOf("Disabled"));

  temp = temp[0] + temp.substring(1).replace(/([A-Z])/g, " $1");

  return temp;
}

function formatCategory(category: string): EmailNotificationCategoryType {
  return category.substring(
    0,
    category.indexOf("Disabled")
  ) as EmailNotificationCategoryType;
}

function getDescription(category: EmailNotificationCategoryType): string {
  switch (category) {
    case "ReleaseNotes":
      return "Receive information about updates, bug fixes, and new features on the Numerous platform.";
    case "Marketing":
      return "Receive marketing and promotional emails from Numerous.";
    case "OrganizationUpdates":
      return "Receive updates related to subscription statuses in your organization(s).";
    case "Onboarding":
      return "Receive emails related to the Numerous onboarding process.";
    case "DeploymentUpdates":
      return "Receive updates about app deployment status.";
    default:
      return "";
  }
}
